import { environment } from "./../../environments/environment";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { Location } from "@angular/common";
import {
  LinkAnnotationService,
  BookmarkViewService,
  MagnificationService,
  ThumbnailViewService,
  ToolbarService,
  NavigationService,
  TextSearchService,
  AnnotationService,
  TextSelectionService,
  PrintService,
} from "@syncfusion/ej2-angular-pdfviewer";

@Component({
  selector: "app-mat",
  templateUrl: "./mat.component.html",
  styleUrls: ["./mat.component.css"],
  providers: [
    LinkAnnotationService,
    BookmarkViewService,
    MagnificationService,
    ThumbnailViewService,
    ToolbarService,
    NavigationService,
    AnnotationService,
    TextSearchService,
    TextSelectionService,
    PrintService,
  ],
})
export class MatComponent implements OnInit {
  mat;
  public service =
    "https://ej2services.syncfusion.com/production/web-services/api/pdfviewer";
  public toolbarSettings = { showTooltip: true, toolbarItem: "DownloadOption" };

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private _location: Location
  ) {
    this.route.queryParams.subscribe((params) => {
      this.http
        .get(`${environment.apiUrl}/material/${params.mat}`)
        .subscribe((data) => {
          this.mat = data["data"];
        });
    });
  }

  ngOnInit() {}

  back() {
    this._location.back();
  }
}
